export default {
  index: {
    text1: "Invite",
    text2: "Assets",
    text3: "Bills",
    text4: "Zone",
    text5: "One-Star Covenant",
    text6: "Subscribe",
    text7: "Two-Star Covenant",
    text8: "Introduction",
    text9: "Join our community",
    text10: "Bind Superior",
    text11: "Please enter referrer address",
    text12: "Confirm",
    text13: "Contribution Incentive Pool",
    text14: "Remaining Rewards",
    text15: "Coming Soon",
	text16: "Partner",
  },
  wallet: {
    text1: "Total Asset Value",
    text2: "Bills",
    text3: "Balance",
    text4: "Withdraw",
    text5: "Whitelist Benefits",
    text6: "IDO Benefits",
    text7: "Subscribe",
 text8: "exchange",
 
 },
 dui :{
 	text1: "兑换白名单权益",
 
 },
  pawn: {
    text1: "Earnings are settled at 18:18 the next day. 70% of daily earnings are settled as USDT, and 30% as equivalent UES tokens. The market value of UES is 3U.",
    text2: "Subscribe",
    text3: "pieces",
    text4: "One-Star Covenant",
    text5: "Daily Earnings",
    text6: "Two-Star Covenant",
    text7: "Three-Star Covenant",
    text8: "Plus Covenant"
  },
  zy: {
    text1: "Earning",
    text2: "Expired",
    text3: "Quantity",
    text5: "Earned",
    text4: "Subscription Date"
  },
  team: {
    text1: "Current Level",
    text2: "My Subscriptions",
    text3: "Sub-zone Performance",
    text4: "My Referrer",
    text5: "Referrer's Subscriptions",
    text6: "My Team",
    text7: "Total Performance",
    text8: "Sub-zone Performance",
    text9: "Number of Team Members",
    text10: "My Referrals",
    text11: "Subscription Quantity",
    text12: "Invitation Link"
  },
  withdrawal: {
    text1: "Withdrawal Quantity",
    text2: "Arrival",
    text3: "Handling Fee",
    text4: "Wallet Balance",
    text5: "Withdrawal Frozen",
    text6: "Confirm",
    text7: "Please enter withdrawal quantity"
  },
  record: {
    text1: "Type",
    text2: "Quantity",
    text3: "Time"
  },
  header: {
    text1: 'More',
    text2: 'Referral Link',
    text3: 'Home',
    text4: 'Wallet',
    text5: 'Subscribe',
    text6: 'My Covenants',
    text7: 'My Team',
	text8: 'RLP白名单',
  },
  lan: {
    text1: 'English',
    text2: 'Simplified Chinese',
    text3: 'Traditional Chinese',
    text4: 'Thai',
    text5: 'Korean',
    text6: 'Japanese',
    text7: 'Vietnamese'
  },
  tost: {
    text1: 'Coming Soon',
    text2: 'Please enter withdrawal quantity',
    text3: 'Insufficient balance',
    text4: 'Copied successfully',
	text5: 'Transfer out at least 50 USDT',
  },
  rlp: {
 text10: "RLP Subscription",
    text1: "100 Whitelist Quota = 0.1BNB Subscription",
    text2: "Subscribe",
    text4: "Subscription Pricing",
    text3: "100 Quota / 0.1BNB",
    text5: "BNB",
    text6: "My Whitelist",
    text7: "Subscribe"
  	
  },
  aitoken: {
    brand: 'GMI Cloud',
    connectWallet: 'Connect Wallet',
    language: 'Language',
    tabs: {
      home: 'Home',
      business: 'Business',
      orders: 'Orders',
      referral: 'Referral',
    },
  },
}
